<li *ngFor="let folder of folders; let i = index" class="folder-item" (click)="selectFolder($event, folder)">
  <div class="folder-item--container" tabindex="{{ i }}" [id]="'folderItem' + i">
    <button
      class="folder-item__collapse-button"
      data-bs-toggle="collapse"
      [attr.data-bs-target]="'#collapseExample' + folder.parent.objectId"
      [attr.aria-expanded]="i === 0 ? true : false"
      aria-controls="collapseExample1"
      (click)="onButtonClicked($event)"
      id="collapse-button"
    >
      <i class="ti-{{ folder.parent.name === 'root' || folder.parent.encryptedId === null ? 'minus-circle' : 'add-plus-circle' }} icon-list" id="collapse-icon"></i>
    </button>
    <img class="icon-list" src="assets/images/suite/storage/file-icons/icon_folder{{ folder.parent.encrypted ? 'secure' : '' }}.svg" alt="folder-svg" />
    <p class="folder-item__title">{{ folder.parent.name !== 'root' ? folder.parent.name && trimStringPipe.transform(folder.parent.name, 30) : ('MY_STORAGE' | translate) }}</p>
  </div>
  <div class="collapse collapse-edit" [ngClass]="{ show: i === 0 && !folder.parent.objectId ? true : false }" [id]="'collapseExample' + folder.parent.objectId">
    <div *ngIf="folder.children.length > 0">
      <app-folder-tree [folders]="folder.children" (selectedFolderHiearachy)="getSelectedFolderHiearachy($event)"></app-folder-tree>
    </div>
  </div>
</li>
